module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-10000-7152b575.png";